"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsAnySetMatcherContext = void 0;
var lang_1 = require("../../utils/lang");
function containsAnySetMatcherContext(ruleAttr) {
    return function containsAnyMatcher(runtimeAttr) {
        var containsAny = false;
        var _loop_1 = function (i) {
            if ((0, lang_1.findIndex)(runtimeAttr, function (e) { return e === ruleAttr[i]; }) >= 0)
                containsAny = true;
        };
        for (var i = 0; i < ruleAttr.length && !containsAny; i++) {
            _loop_1(i);
        }
        return containsAny;
    };
}
exports.containsAnySetMatcherContext = containsAnySetMatcherContext;
